module.exports = __webpack_public_path__ + "img/arrow-right-disabled.b54de6d2.svg";